import React, { useState } from "react";
import "./DeleteAccount.css";

const DeleteAccount = () => {
  const [form, setForm] = useState({ name: "", email: "", reason: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Normally here you'd send data to backend or Firestore
    console.log("Account delete request submitted:", form);

    setSubmitted(true);
    setForm({ name: "", email: "", reason: "" });
  };

  return (
    <section className="delete-account">
      <div className="delete-container">
        <h1>Account Deletion Request</h1>
        <p>
          Submit this form if you wish to permanently delete your Cleanering
          account. Our team will process your request within{" "}
          <strong>2 working days</strong>.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your registered email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Reason for Deletion</label>
            <textarea
              name="reason"
              rows="4"
              placeholder="Why do you want to delete your account?"
              value={form.reason}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="btn-submit">
            Submit Request
          </button>
        </form>

        {submitted && (
          <div className="popup">
            <div className="popup-box">
              <i className="fa-solid fa-check-circle"></i>
              <h3>Request Submitted!</h3>
              <p>
                Thank you. Your account deletion request has been received.
                <br />
                Our team will delete your account within{" "}
                <strong>2 working days.</strong>
              </p>
              <button onClick={() => setSubmitted(false)}>Close</button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DeleteAccount;